import SchoolRounded from '@mui/icons-material/SchoolRounded';
import { Outlet, type RouteObject } from 'react-router';
import { RequireRole } from '@/platform/guards';
import type { FrontModule } from '@/modules/types';
import { HomeStudent } from './components/HomeWidgets';

const page = (
  loader: () => Promise<Record<string, React.ComponentType>>,
  name: string,
): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await loader())[name] }),
});

/** Lousa ENEM: simulados built by each student, essays with AI, personal plans. Back-end: back/app/modules/enem. */
export const enemModule: FrontModule = {
  key: 'enem',
  icon: SchoolRounded,
  nav: [
    {
      to: '/enem',
      label: 'ENEM',
      icon: SchoolRounded,
      roles: ['admin', 'coordinator', 'teacher', 'student'],
    },
  ],
  routes: [
    { path: '/enem', ...page(() => import('./pages/EnemHomePage'), 'EnemHomePage') },
    { path: '/enem/novo', ...page(() => import('./pages/BuilderPage'), 'BuilderPage') },
    {
      path: '/enem/simulados/:simuladoId',
      ...page(() => import('./pages/SimuladoPage'), 'SimuladoPage'),
    },
    { path: '/enem/redacao', ...page(() => import('./pages/RedacaoPage'), 'RedacaoPage') },
    { path: '/enem/redacao/:essayId', ...page(() => import('./pages/EssayPage'), 'EssayPage') },
    { path: '/enem/planos', ...page(() => import('./pages/EnemPlansPage'), 'EnemPlansPage') },
    {
      element: (
        <RequireRole roles={['admin']}>
          <Outlet />
        </RequireRole>
      ),
      children: [
        { path: '/admin/enem', ...page(() => import('./pages/AdminEnemPage'), 'AdminEnemPage') },
      ],
    },
  ],
  HomeStudent,
};
